import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import { ThemeProvider } from './lib/theme/theme-provider';
import { queryClient } from './lib/query-client';
import 'react-grid-layout/css/styles.css';
/*
   Fraunces self-hosted via @fontsource (2026-08-06) — importado aqui (via JS,
   nao via @import dentro de globals.css) de proposito: Tailwind 4 processa
   @import de CSS ANTES do pipeline de assets do Vite, o que achata o
   arquivo do @fontsource pro contexto de globals.css e quebra a resolucao
   dos url() relativos (./files/fraunces-latin-600-normal.woff2) — build
   real reproduziu isso (arquivo nao aparecia em dist/, warning "didn't
   resolve at build time"). Import direto no entry point e o padrao oficial
   do @fontsource pra Vite e evita o problema (mesmo mecanismo ja usado
   acima pro CSS do react-grid-layout).
*/
import '@fontsource/fraunces/latin-600.css';
import './styles/globals.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Elemento #root não encontrado em index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
